import { apiServiceProviderUrl } from './config';

const urls = {
  authentication: 'authentication',
  dashboard: 'dashboard',
  bankAccounts: 'bank-accounts',
  tiles: 'admin/tiles',
  adminCategories: 'admin/categories',
  profile: 'profile',
  users: 'admin/users',
  adminCourse: 'admin/courses',
  adminDebtors: 'admin/debtors',
  adminNotification: 'admin/notifications',
  notifications: 'notifications',
  course: 'courses',
  home: 'home',
  categories: 'categories',
  drive: 'drive',
  captcha: 'captcha',
  adminPaymentDocument: 'admin/payment-documents',
  adminMembership: 'admin/membership',
  paymentDocument: 'payment-documents',
  adminUserfunds: 'admin/userfunds',
  adminUserWarranties: 'admin/user-warranties',
  adminfunds: 'admin/funds',
  adminReport: 'admin/report',
  adminTodos: 'admin/todos',
  adminSettings: 'admin/settings',
  userfunds: 'userfunds',
  userValidations: 'user-validation',
};

const data = {
  captcha: {
    imageUrl: `${apiServiceProviderUrl}/${urls.captcha}`,
  },
  userValidation: {
    list: `${urls.userValidations}/list`,
  },
  authentication: {
    login: `${urls.authentication}/login`,
    loginByOtp: `${urls.authentication}/login-by-otp`,
    loginByAdmin: `${urls.authentication}/login-by-admin`,
    register: `${urls.authentication}/register`,
    userInfo: `${urls.authentication}/user-info`,
    refresh: `${urls.authentication}/refresh`,
    sendOtp: `${urls.authentication}/send-otp`,
  },
  userFunds: {
    init: `${urls.userfunds}/init-funds`,
  },
  adminReport: {
    initFunds: `${urls.adminReport}/init-funds`,
    initDeptsMonthly: `${urls.adminReport}/init-depts-monthly`,
    downloadDeptsMonthly: `${apiServiceProviderUrl}/${urls.adminReport}/download-depts-monthly`,
    initMainReport: (fundId) => `${urls.adminReport}/init-main-report/${fundId}`,
  },
  adminSettings: {
    initSettings: `${urls.adminSettings}/init`,
    saveSetting: `${urls.adminSettings}/save`,
  },
  adminTodos: {
    initTodos: `${urls.adminTodos}/init`,
    getTodo: (todoId) => `${urls.adminTodos}/${todoId}`,
    saveTodo: `${urls.adminTodos}/save`,
  },
  adminUserWarranties: {
    initWarranties: (userId) => `${urls.adminUserWarranties}/init-warranties/${userId}`,
    saveWarranty: `${urls.adminUserWarranties}/save-warranty`,
    deleteWarranty: (warrantyId) => `${urls.adminUserWarranties}/delete-warranty/${warrantyId}`,
  },
  adminUserFunds: {
    initUserFunds: (userId) => `${urls.adminUserfunds}/init-user-funds/${userId}`,
    toggleActive: (userId, fundId) => `${urls.adminUserfunds}/toggle-active/${userId}/${fundId}`,
    deleteUserFund: (userFundId) => `${urls.adminUserfunds}/delete-user-fund/${userFundId}`,
    applyUserFund: `${urls.adminUserfunds}/apply-user-fund`,
  },
  adminfunds: {
    initFunds: `${urls.adminfunds}/init-funds`,
    applyFund: `${urls.adminfunds}/apply-fund`,
    deleteFund: (fundId) => `${urls.adminfunds}/delete-fund/${fundId}`,
  },
  dashboard: {
    dashboard: `${urls.dashboard}/`,
  },
  bankAccounts: {
    initMyAccounts: `${urls.bankAccounts}`,
    saveChanges: `${urls.bankAccounts}`,
    byAdmin: `${urls.bankAccounts}/by-admin`,
    delete: (id) => `${urls.bankAccounts}/delete/${id}`,
  },
  course: {
    initCoursePoster: (courseId, width, height) =>
      `${apiServiceProviderUrl}/${urls.course}/poster/${courseId}/${width}/${height}`, //?${new Date().getUTCMilliseconds()}
    initCourse: (courseId) => `${urls.course}/init/${courseId}`,
  },
  home: {
    initHome: `${urls.home}/init`,
  },
  categories: {
    init: (id) => `${urls.categories}/${id}`,
    initCoursePoster: (categoryId, width, height) =>
      `${apiServiceProviderUrl}/${urls.categories}/poster/${categoryId}/${width}/${height}`, //?${new Date().getUTCMilliseconds()}
  },
  paymentDocument: {
    initSenderPaymentDocuments: `${urls.paymentDocument}/init-sender-payment-documents`,
    initSenderPaymentDocument: (paymentDocumentDepositorId) =>
      `${urls.paymentDocument}/init-sender-payment-documents/${paymentDocumentDepositorId}`,
    initMinePaymentDocument: (userFundId) => `${urls.paymentDocument}/init-mine-payment-documents/${userFundId}`,
    setPaymentDocumentBankId: `${urls.paymentDocument}/set-payment-document-bank-id`,
    sendDocumentForPayment: (id) => `${urls.paymentDocument}/send-document-for-payment/${id}`,
    deleteReceipt: (id) => `${urls.paymentDocument}/delete-receipt/${id}`,
    uploadReceipt: `${urls.paymentDocument}/upload-receipt`,
    receiptDownloadUrl: (id) => `${apiServiceProviderUrl}/${urls.paymentDocument}/download-receipt/${id}`,
  },
  admin: {
    memberships: {
      initUserMemberships: (userId) => `${urls.adminMembership}/init-user-memberships/${userId}`,
      deleteMembership: (userId) => `${urls.adminMembership}/delete-membership/${userId}`,
      initSaveMembership: (userId) => `${urls.adminMembership}/init-save-membership/${userId}`,
      saveMembership: `${urls.adminMembership}/save-membership`,
    },
    paymentDocument: {
      list: `${urls.adminPaymentDocument}/list`,
      initCreate: `${urls.adminPaymentDocument}/init-create`,
      saveChanges: `${urls.adminPaymentDocument}/save-changes`,
      suggestDeptors: `${urls.adminPaymentDocument}/suggest-deptors`,
      setDepositorStatus: `${urls.adminPaymentDocument}/set-depositor-status`,
      initUserFund: (userFundId) => `${urls.adminPaymentDocument}/init/${userFundId}`,
      initUserPaymentHistories: (userId) => `${urls.adminPaymentDocument}/init-user-payment-histories/${userId}`,
      deleteDepositor: (id) => `${urls.adminPaymentDocument}/delete-depositor/${id}`,
      sendForBankAccount: (id) => `${urls.adminPaymentDocument}/send-for-bank-account/${id}`,
      closePaymentDocument: (id) => `${urls.adminPaymentDocument}/close-payment-document/${id}`,
      goBackStatus: (id) => `${urls.adminPaymentDocument}/go-back-status/${id}`,
    },
    tiles: {
      init: `${urls.tiles}/init`,
      save: `${urls.tiles}/save-changes`,
      add: `${urls.tiles}/add`,
      delete: (id) => `${urls.tiles}/delete?id=${id}`,
    },
    categories: {
      init: `${urls.adminCategories}/init`,
      save: `${urls.adminCategories}/save-changes`,
      delete: (id) => `${urls.adminCategories}/delete?id=${id}`,
    },
    users: {
      init: `${urls.users}/init`,
      saveChanges: `${urls.users}/save-changes`,
      delete: (id) => `${urls.users}/delete?id=${id}`,
      resetPassword: (id) => `${urls.users}/reset-pass?id=${id}`,
    },
  },
  profile: {
    init: `${urls.profile}/init`,
    save: `${urls.profile}/save`,
    changePassword: `${urls.profile}/change-password`,
    uploadProfilePhoto: `${urls.profile}/upload-profile-photo`,
    profileImageUrl: (userId) => `${apiServiceProviderUrl}/${urls.profile}/profile-image/${userId}`,
  },
  adminCourse: {
    initCourses: `${urls.adminCourse}/init-courses`,
    initCourse: (id) => `${urls.adminCourse}/init-course/${id}`,
    saveChanges: `${urls.adminCourse}/save-changes`,
    delete: (id) => `${urls.adminCourse}/delete/${id}`,
  },
  adminDebtors: {
    initDebtors: `${urls.adminDebtors}/`,
  },
  notifications: {
    init: `${urls.notifications}/init`,
    unreads: `${urls.notifications}/unreads`,
    detail: (id) => `${urls.notifications}/${id}`,
    markAsRead: (id) => `${urls.notifications}/mark-as-read/${id}`,
  },
  adminNotification: {
    initAll: `${urls.adminNotification}/init-all`,
    send: `${urls.adminNotification}/send`,
    delete: (id) => `${urls.adminNotification}/delete/${id}`,
  },
  drive: {
    objects: (parentId) => `${urls.drive}/objects/${parentId}`,
    delete: (id) => `${urls.drive}/delete/${id}`,
    deleteMember: (id) => `${urls.drive}/delete-member/${id}`,
    saveChanges: `${urls.drive}/save-changes`,
    download: (id) => `${apiServiceProviderUrl}/${urls.drive}/download/${id}`,
    downloadWithDimentions: (id, width, height) =>
      `${apiServiceProviderUrl}/${urls.drive}/download/${id}/${width}/${height}`,
    upload: `${urls.drive}/upload`,
    initAccessUsers: (driveId) => `${urls.drive}/get-access-users/${driveId}`,
    saveAccess: `${urls.drive}/save-access`,
  },
};

export default data;
